import React from 'react';
import {Text, useTheme, View} from "@aws-amplify/ui-react";

export default function Footer() {
  const {tokens} = useTheme();

  const year = new Date().getFullYear();

  return (
    <View textAlign="center" padding={tokens.space.large}>
      <Text className="footerText">
        <a href="https://myedu.it/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>&nbsp;|
        &nbsp;<a href="/cookie-policy" target="_blank" rel="noreferrer">Cookie Policy</a>&nbsp;|
        &nbsp;<a href="/assistenza" target="_blank" rel="noreferrer">Assistenza</a>&nbsp;|<br />
        Copyright {year} FME Education S.p.A - P.I. 08233380966
      </Text>
    </View>
  );
}